// Accent du tenant (T-333 / M-7) : `data-accent` sur <html>, lu par index.css.
// Valeur DÉCLARÉE par le tenant (`config.accent`, servie par /user/tenants) ;
// absente ou inconnue ⇒ attribut retiré ⇒ accent par défaut (bleu TEF).
// ⛔ Aucun nom de tenant ni business_model n'intervient ici.

export const ACCENTS_TENANT = ["tef", "omv", "climat"];
const CLE = "current_accent";

export function accentValide(accent) {
  return ACCENTS_TENANT.includes(accent) ? accent : null;
}

export function appliquerAccent(accent) {
  const valide = accentValide(accent);
  try {
    if (valide) localStorage.setItem(CLE, valide);
    else localStorage.removeItem(CLE);
  } catch { /* stockage indisponible : l'attribut suffit pour la session */ }
  const racine = document.documentElement;
  if (valide) racine.setAttribute("data-accent", valide);
  else racine.removeAttribute("data-accent");
  return valide;
}

export function appliquerAccentDuTenant(tenant) {
  return appliquerAccent(tenant && tenant.accent);
}

export function retablirAccentMemorise() {
  let memo = null;
  try { memo = localStorage.getItem(CLE); } catch { /* ignoré */ }
  return appliquerAccent(memo);
}
